export default __webpack_public_path__ + "assets/ttf/d041ec5e0338d25c63c27b24b76e4bb0.ttf";